import { useEffect } from 'react'
import { useGlobalVariablesContext } from '../context/GlobalVariablesContext'

/**
 * Hook para aplicar dinámicamente los colores de Bootstrap y selector de capas desde config.json
 */
const useBootstrapTheme = () => {
  const { config } = useGlobalVariablesContext()

  useEffect(() => {
    if (!config?.STYLES_APP) return

    const { primaryColor, overPrimaryColor, secondaryColor } = config.STYLES_APP

    // Crear estilos dinámicos para btn-primary
    const primaryStyles = `
      .btn-primary {
        background-color: ${overPrimaryColor} !important;
        border-color: ${overPrimaryColor} !important;
        color: #fff !important;
      }
      
      .btn-primary:hover {
        background-color: ${primaryColor} !important;
        border-color: ${primaryColor} !important;
        color: #fff !important;
      }
      
      .btn-primary:focus {
        background-color: ${primaryColor} !important;
        border-color: ${primaryColor} !important;
        box-shadow: 0 0 0 0.2rem ${primaryColor}25 !important;
      }
      
      .btn-primary:active {
        background-color: ${primaryColor} !important;
        border-color: ${primaryColor} !important;
      }
      
      .btn-primary:disabled {
        background-color: #6c757d !important;
        border-color: #6c757d !important;
        opacity: 0.65 !important;
      }
    `

    // Crear estilos dinámicos para btn-secondary
    const secondaryStyles = `
      .btn-secondary {
        background-color: #000000 !important;
        border-color: #000000 !important;
        color: #fff !important;
      }
      
      .btn-secondary:hover {
        background-color: #6c757d !important;
        border-color: #6c757d !important;
        color: #fff !important;
      }
      
      .btn-secondary:focus {
        background-color: #6c757d !important;
        border-color: #6c757d !important;
        box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.25) !important;
      }
      
      .btn-secondary:active {
        background-color: #6c757d !important;
        border-color: #6c757d !important;
      }
      
      .btn-secondary:disabled {
        background-color: #6c757d !important;
        border-color: #6c757d !important;
        opacity: 0.65 !important;
      }
    `

    // Crear estilos dinámicos para el selector de capas
    const layerSelectorStyles = `
      .layer-selector input[type="checkbox"]:checked {
        background-color: ${primaryColor} !important;
        border-color: ${primaryColor} !important;
      }
      
      .layer-selector input[type="checkbox"]:checked:focus {
        box-shadow: 0 0 0 0.2rem ${primaryColor}25 !important;
      }
      
      .layer-selector .group-folder-icon {
        color: ${primaryColor} !important;
      }
      
      .layer-selector .grupo .group-folder-icon {
        color: ${primaryColor} !important;
      }
      
      .layer-selector input[type="range"]::-webkit-slider-thumb {
        background-color: ${primaryColor} !important;
      }
      
      .layer-selector input[type="range"]::-moz-range-thumb {
        background-color: ${primaryColor} !important;
      }
      
      .layer-selector .layer-tools button {
        color: ${overPrimaryColor} !important;
      }
      
      .layer-selector .layer-tools button:hover {
        color: ${primaryColor} !important;
      }
      
      .layer-selector .bi-info-circle {
        color: ${overPrimaryColor} !important;
      }
      
      .layer-selector .bi-arrow-clockwise {
        color: ${overPrimaryColor} !important;
      }
      
      .layer-selector .bi-table {
        color: ${overPrimaryColor} !important;
      }
      
      /* Colores para textos del selector de capas */
      .layer-selector .group-title {
        color: ${primaryColor} !important;
      }
      
      .layer-selector .layer-title {
        color: ${primaryColor} !important;
      }
      
  
      
      /* Asegurar que el color se aplique incluso con estilos inline */
      .layer-selector .grupo i.folder-icon {
        color: ${overPrimaryColor} !important;
      }
      
      /* Sobrescribir cualquier estilo de Bootstrap Icons y el color del body */
      .layer-selector .grupo i.bi-folder-fill,
      .layer-selector .grupo i.bi-folder2-open,
      .layer-selector .grupo i.folder-icon {
        color: ${overPrimaryColor} !important;
      }
      
      /* Forzar el color incluso si hereda del body */
      .layer-selector .grupo i[class*="bi-folder"] {
        color: ${overPrimaryColor} !important;
      }
      
      /* Sobrescribir específicamente el color del body para iconos de carpeta */
      .layer-selector .grupo i.bi-folder-fill,
      .layer-selector .grupo i.bi-folder2-open {
        color: ${overPrimaryColor} !important;
        color: ${overPrimaryColor} !important;
      }
      
      /* Color para la clase .grupo .bi */
      .layer-selector .grupo .bi {
        color: ${primaryColor} !important;
      }
      
    `

    // Crear o actualizar el elemento style
    let styleElement = document.getElementById('bootstrap-theme-styles')
    if (!styleElement) {
      styleElement = document.createElement('style')
      styleElement.id = 'bootstrap-theme-styles'
      document.head.appendChild(styleElement)
    }

    styleElement.textContent = primaryStyles + secondaryStyles + layerSelectorStyles

    // Cleanup al desmontar
    return () => {
      if (styleElement && styleElement.parentNode) {
        styleElement.parentNode.removeChild(styleElement)
      }
    }
  }, [config])

  return null
}

export default useBootstrapTheme
